import React from 'react'
import styles from './VNSecureDots.module.scss'

/**
 * Password input indicator dots
 *
 * @param {*} param0
 * @returns
 */
const VNSecureDots = ({ count = 4, subjectSize = 0 }) => {
  const dots = Array.from({ length: count }, (_, index) => {
    const active = index + 1 <= subjectSize
    return <span key={index} className={`${styles.dot} ${active ? styles.active : ''}`}></span>
  })

  return <div className={styles.container}>{dots}</div>
}

export default VNSecureDots
